'use strict';
import { react2angular } from 'react2angular';
import InvoiceSlider from '../../src/views/invoice-details/components/invoice-slider/InvoiceSliderWrapper';

angular.module('dstreamApp.reactBridge').component('dsInvoiceSlider', react2angular(InvoiceSlider, ['invoice', 'reloadInvoiceData'], ['location', '$rootScope']));
